import { SelectItem } from "primereact/selectitem";
import { BaseService } from "./base.service";
import { API_ENDPOINTS } from "../utils/endpoints";

class CountriesService extends BaseService {
  async getCountriesAsSelectOptions(): Promise<SelectItem[]> {
    const url = `${this.endpointPath}/all-as-options`;
    return this.http.get<SelectItem[]>(url).then((response) => response.data);
  }
}

export const countriesService = new CountriesService(API_ENDPOINTS.COUNTRIES);
